import { useEffect, useState } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Form, Layout, Spin, message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { createCorporate } from 'services/corporate.service'
import { useGlobalStore } from 'stores/global'
import FormManageCorporate from 'components/features/corporate/components/FormManageCorporate'
import { Popup } from 'components/common/portal/Popup'

const Content = Layout.Content

const CreateCorporatePage = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const { setPageHeader } = useGlobalStore()
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setPageHeader({
      title: 'Corporates',
      subTitle: 'Create New Corporate',
      onBack: '/corporates',
      backIcon: null,
      extra: [],
    })
  }, [])

  const onFinish = (value) => {
    setLoading(true)
    const body = value
    createCorporate(body)
      .then((payload) => {
        if (payload.status.code === 201) {
          Popup({
            title: 'บันทึกข้อมูลสำเร็จ',
            message: 'ระบบบันทึกข้อมูลสำเร็จแล้ว',
            okText: 'ตกลง',
            onOk: () => navigate('/corporates'),
            status: 'success',
          })
        }
        setLoading(false)
      })
      .catch((err) => {
        if (err.error.code === 409) {
          form.setFields([
            {
              name: 'taxId',
              errors: [''],
            },
            {
              name: 'corporateNumber',
              errors: ['please verify tax id and vendor code (corporate number) already existed'],
            },
          ])
          form.resetFields(['taxId', 'corporateNumber'])
          form.scrollToField('taxId', { behavior: 'smooth' })
          Popup({
            title: 'พบข้อมูลซ้ำในระบบ',
            message: <div className='text-xl font-bold'>กรุณาทำรายการใหม่อีกครั้ง</div>,
            okText: 'ตกลง',
            status: 'error',
          })
        } else {
          Popup({
            title: 'บันทึกไม่สำเร็จ',
            message: <div className='text-xl font-bold'>กรุณาทำรายการใหม่อีกครั้ง</div>,
            okText: 'ตกลง',
            status: 'error',
          })
        }
        message.error('Something went wrong')
        setLoading(false)
      })
  }

  const onFinishFailed = (error) => {
    console.log(error)
  }

  return (
    <>
      <Content>
        <div className='w-2/3 m-auto m'>
          <div className='steps-content mt-10'>
            <Form
              form={form}
              name='order-form'
              layout='vertical'
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
              requiredMark={false}
              scrollToFirstError={{
                behavior: 'smooth',
              }}
            >
              <Spin
                tip='Loading...'
                spinning={loading}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
              >
                <div>
                  <FormManageCorporate form={form} />
                </div>
              </Spin>
            </Form>
          </div>
        </div>
      </Content>
    </>
  )
}

export default CreateCorporatePage
